module.exports = __webpack_public_path__ + "media/advanced_lecture2.7c7644a0.mp4";